import { text, type LocalizedText } from '@tb/shared';

export const DICTIONARY = {
  'boot.loading': text('Loading', 'Загрузка'),
  'boot.failed': text('Could not start', 'Не удалось запустить'),
  'boot.retry': text('Try again', 'Попробовать снова'),

  'session.outside.title': text('Open this from Telegram', 'Откройте из Telegram'),
  'session.outside.body': text(
    'TON Builder runs as a Telegram Mini App. Start the bot and tap the button it sends you.',
    'TON Builder работает как мини-приложение Telegram. Запустите бота и нажмите кнопку в его сообщении.',
  ),
  'session.outside.button': text('Open the bot', 'Открыть бота'),
  'session.failed': text('Could not sign in', 'Не удалось войти'),

  'wallet.connect': text('Connect', 'Подключить'),
  'wallet.connecting': text('Connecting', 'Подключаем'),
  'wallet.disconnect': text('Disconnect', 'Отключить'),
  'wallet.notConfirmed': text('Wallet not confirmed', 'Кошелёк не подтверждён'),

  'home.greeting': text('Hello, {name}', 'Привет, {name}'),
  'home.tagline': text(
    'Put a real website on a .ton domain you already own.',
    'Опубликуйте настоящий сайт на своём .ton домене.',
  ),
  'home.testnet.title': text('Testnet', 'Тестовая сеть'),
  'home.testnet.body': text(
    'This instance talks to the TON testnet. Domains and transactions here are not the mainnet ones.',
    'Это подключение к тестовой сети TON. Домены и транзакции здесь не из основной сети.',
  ),
  'home.connect.title': text('Connect your wallet', 'Подключите кошелёк'),
  'home.connect.body': text(
    'We read which .ton domains it holds. Publishing always needs your signature.',
    'Мы посмотрим, какие .ton домены на нём. Публикация всегда требует вашей подписи.',
  ),
  'home.connect.button': text('Connect wallet', 'Подключить кошелёк'),
  'home.domains.error': text('Could not read your domains', 'Не удалось получить список доменов'),
  'home.domains.title': text('Your domains', 'Ваши домены'),
  'home.domains.refresh': text('Refresh', 'Обновить'),
  'home.empty.title': text('No .ton domains on this wallet', 'На этом кошельке нет .ton доменов'),
  'home.empty.body': text(
    'A domain is what a site is published to, so you need one before you can build. Domains are NFTs: buy one, and it shows up here automatically.',
    'Домен — это то, куда публикуется сайт, поэтому без него собрать нечего. Домены это NFT: купите — и он появится здесь сам.',
  ),
  'home.empty.get': text('Get a .ton domain', 'Получить .ton домен'),
  'home.empty.already': text('I already bought one', 'Я уже купил'),
  'home.domain.publishedByUs': text('Published from here', 'Опубликован отсюда'),
  'home.domain.publishedElsewhere': text(
    'Points at a bag created elsewhere',
    'Указывает на bag, созданный не здесь',
  ),
  'home.domain.notPublished': text('No site published yet', 'Сайт ещё не опубликован'),
  'home.domain.build': text('Build a site', 'Собрать сайт'),
  'home.domain.open': text('Open site', 'Открыть сайт'),
  'home.recent': text('Recently edited', 'Недавние'),

  'new.title': text('Choose a starting point', 'С чего начать'),
  'new.subtitle': text(
    'You can switch templates later, but the code editor and templates are separate kinds of site.',
    'Шаблон можно поменять позже, но редактор кода и шаблоны — это разные типы сайта.',
  ),
  'new.error': text('Could not create the site', 'Не удалось создать сайт'),
  'new.templates': text('Templates', 'Шаблоны'),
  'new.templatesFailed': text('Templates could not be loaded.', 'Не удалось загрузить шаблоны.'),
  'new.custom.section': text('Or write it yourself', 'Или напишите сами'),
  'new.custom.title': text('Custom code', 'Свой код'),
  'new.custom.body': text(
    'Your own HTML, CSS and JavaScript, with file uploads and a live preview.',
    'Свои HTML, CSS и JavaScript, с загрузкой файлов и живым предпросмотром.',
  ),
  'new.continue': text('Continue', 'Продолжить'),
  'new.needWallet': text(
    'Connect your wallet to continue.',
    'Подключите кошелёк, чтобы продолжить.',
  ),

  'site.loadFailed': text('Could not load the site', 'Не удалось загрузить сайт'),
  'site.kind.template': text('Template: {name}', 'Шаблон: {name}'),
  'site.kind.custom': text('Custom code', 'Свой код'),
  'site.live': text('Live', 'Опубликован'),
  'site.notPublished': text('Not published', 'Не опубликован'),
  'site.field.bag': text('Bag', 'Bag'),
  'site.field.published': text('Published', 'Опубликован'),
  'site.field.size': text('Size', 'Размер'),
  'site.nothingOnChain': text(
    'Nothing is on chain yet. Build the page, then publish it with one signature.',
    'В сети пока ничего нет. Соберите страницу и опубликуйте одной подписью.',
  ),
  'site.openIt': text('Open it', 'Открыть'),
  'site.copyLink': text('Copy address', 'Скопировать адрес'),
  'site.openLink': text('Open in browser', 'Открыть в браузере'),
  'site.copied': text('Copied', 'Скопировано'),
  'site.tonAddress': text('On TON', 'В сети TON'),
  'site.openHint': text(
    '{domain} opens in Telegram, in wallets with a built-in browser, and anywhere else TON Proxy reaches.',
    '{domain} открывается в Telegram, в кошельках со встроенным браузером и везде, куда дотягивается TON Proxy.',
  ),
  'site.lastFailed': text('The last attempt failed', 'Прошлая попытка не удалась'),
  'site.inProgress': text('In progress', 'В процессе'),
  'site.packing': text('Packing your site into a bag.', 'Упаковываем сайт в bag.'),
  'site.waitingChain': text(
    'Waiting for the domain record to change on chain.',
    'Ждём, когда запись домена обновится в сети.',
  ),
  'site.unpublished.title': text('Unpublished changes', 'Неопубликованные изменения'),
  'site.unpublished.body': text(
    'Your edits are saved but not on chain yet. Publishing costs a small amount of gas and needs your signature.',
    'Правки сохранены, но ещё не в сети. Публикация стоит немного газа и требует вашей подписи.',
  ),
  'site.needsSiteRecord.title': text(
    'Does not open in Telegram yet',
    'Пока не открывается в Telegram',
  ),
  'site.needsSiteRecord.body': text(
    'The domain points at your files, but not at the proxy that Telegram and other TON Proxy clients use to reach them. Publish once more to add that record. Nothing on the page changes.',
    'Домен указывает на ваши файлы, но не на прокси, через который до них добираются Telegram и другие клиенты TON Proxy. Опубликуйте ещё раз, чтобы добавить эту запись. Содержимое страницы не изменится.',
  ),
  'site.publishFix': text('Add the record', 'Добавить запись'),
  'site.upToDate': text('Everything is published', 'Всё опубликовано'),
  'site.edit': text('Edit the page', 'Редактировать страницу'),
  'site.publish': text('Publish', 'Опубликовать'),
  'site.publishUpdate': text('Publish update', 'Опубликовать обновление'),
  'site.history': text('Version history', 'История версий'),

  'editor.tab.content': text('Content', 'Содержимое'),
  'editor.tab.code': text('Code', 'Код'),
  'editor.tab.files': text('Files', 'Файлы'),
  'editor.tab.page': text('Page', 'Страница'),
  'editor.tab.preview': text('Preview', 'Предпросмотр'),
  'editor.openFailed': text('Could not open the editor', 'Не удалось открыть редактор'),
  'editor.templateGone.title': text('Template unavailable', 'Шаблон недоступен'),
  'editor.templateGone.body': text(
    'This template is no longer shipped. Your content is safe, but it cannot be rendered until the template returns.',
    'Этот шаблон больше не поставляется. Содержимое сохранено, но отрисовать его нельзя, пока шаблон не вернётся.',
  ),
  'editor.save': text('Save', 'Сохранить'),
  'editor.saveFailed': text('Could not save', 'Не удалось сохранить'),
  'editor.publish': text('Publish', 'Опубликовать'),

  'editor.settings.title': text('Page title', 'Заголовок страницы'),
  'editor.settings.titleHint': text(
    'Shown in the browser tab and in link previews.',
    'Показывается во вкладке браузера и в превью ссылок.',
  ),
  'editor.settings.description': text('Description', 'Описание'),
  'editor.settings.descriptionHint': text(
    'Used by search engines and chat previews.',
    'Используется поисковиками и превью в мессенджерах.',
  ),
  'editor.settings.language': text('Language', 'Язык сайта'),
  'editor.settings.languageHint': text(
    'Two-letter code, for example en or ru. It sets the language of the published page, not of this editor.',
    'Двухбуквенный код, например en или ru. Задаёт язык опубликованной страницы, а не этого редактора.',
  ),
  'editor.settings.form': text('Contact form', 'Форма связи'),
  'editor.settings.formHint': text(
    'Messages sent from the page arrive in this Telegram chat.',
    'Сообщения со страницы приходят в этот чат Telegram.',
  ),

  'editor.code.loadFailed': text('The editor could not be loaded', 'Не удалось загрузить редактор'),
  'editor.code.loadFailedBody': text(
    'Your code is safe. This is usually a dropped connection while the editor was being fetched.',
    'Код цел. Обычно это оборвавшееся соединение в момент загрузки редактора.',
  ),
  'editor.code.retry': text('Try again', 'Попробовать снова'),
  'editor.code.assetHint': text(
    'Reference an uploaded file with asset://ID. It is rewritten to the file path inside the published bag.',
    'Ссылайтесь на загруженный файл как asset://ID. При публикации он заменится на путь внутри bag.',
  ),

  'editor.files.title': text('Files', 'Файлы'),
  'editor.files.limit': text('Up to {size} each', 'До {size} каждый'),
  'editor.files.empty': text(
    'Nothing uploaded yet. Images and fonts you add here are packed into the published bag.',
    'Пока ничего не загружено. Изображения и шрифты попадут в опубликованный bag.',
  ),
  'editor.files.upload': text('Upload a file', 'Загрузить файл'),
  'editor.files.uploadImage': text('Upload an image', 'Загрузить изображение'),
  'editor.files.remove': text('Remove {name}', 'Удалить {name}'),
  'editor.files.copied': text('Copied', 'Скопировано'),

  'editor.preview.failed': text('Preview failed', 'Предпросмотр не удался'),
  'editor.preview.retry': text('Retry', 'Повторить'),
  'editor.preview.note': text(
    'The preview runs in a sandbox, so links and forms are inert here. They work on the published site.',
    'Предпросмотр работает в песочнице, поэтому ссылки и формы здесь неактивны. На опубликованном сайте они работают.',
  ),

  'form.add': text('Add', 'Добавить'),
  'form.moveUp': text('Move up', 'Вверх'),
  'form.moveDown': text('Move down', 'Вниз'),
  'form.remove': text('Remove', 'Удалить'),
  'form.notSet': text('Not set', 'Не задано'),
  'form.allFiles': text('All files', 'Все файлы'),
  'form.removeImage': text('Remove image', 'Убрать изображение'),

  'publish.title': text('Publish', 'Публикация'),
  'publish.what': text('What happens', 'Что произойдёт'),
  'publish.step.pack.title': text('Pack', 'Упаковка'),
  'publish.step.pack.body': text(
    'Your page becomes a TON Storage bag we seed.',
    'Страница превращается в bag в TON Storage, который мы раздаём.',
  ),
  'publish.step.sign.title': text('Sign', 'Подпись'),
  'publish.step.sign.body': text(
    'One transaction from your wallet, about {amount} GRAM of gas. Any excess is refunded.',
    'Одна транзакция из вашего кошелька, около {amount} GRAM газа. Излишек вернётся.',
  ),
  'publish.step.point.title': text('Point the domain', 'Привязка домена'),
  'publish.step.point.body': text(
    "The transaction writes the bag id into your domain's storage record.",
    'Транзакция запишет идентификатор bag в storage-запись вашего домена.',
  ),
  'publish.noKeys': text(
    'We never hold your keys. Only your wallet can change where {domain} points.',
    'Мы не храним ваши ключи. Изменить, куда указывает {domain}, может только ваш кошелёк.',
  ),
  'publish.pack': text('Pack the site', 'Упаковать сайт'),
  'publish.packing': text('Packing your site into a bag', 'Упаковываем сайт в bag'),
  'publish.packingHint': text(
    'This usually takes a few seconds. You can leave the screen; the work continues.',
    'Обычно занимает несколько секунд. Экран можно закрыть, работа продолжится.',
  ),
  'publish.ready': text('Ready to sign', 'Готово к подписи'),
  'publish.field.domain': text('Domain', 'Домен'),
  'publish.field.bag': text('Bag', 'Bag'),
  'publish.field.size': text('Size', 'Размер'),
  'publish.field.gas': text('Gas', 'Газ'),
  'publish.size': text('{size} in {count} file(s)', '{size} в {count} файл(ах)'),
  'publish.gasUpTo': text('up to {amount} GRAM', 'до {amount} GRAM'),
  'publish.sign': text('Sign in your wallet', 'Подписать в кошельке'),
  'publish.confirming': text('Waiting for the chain', 'Ждём подтверждения сети'),
  'publish.confirmingHint': text(
    'The transaction was accepted by your wallet. We watch the domain record until it shows the new bag, then the bot messages you.',
    'Кошелёк принял транзакцию. Мы следим за записью домена и напишем в бот, когда она обновится.',
  ),
  'publish.done.title': text('{domain} is live', '{domain} опубликован'),
  'publish.done.body': text(
    'The domain now points at your new bag. It may take a moment to appear in wallet browsers while the record propagates.',
    'Домен теперь указывает на новый bag. В браузерах кошельков он появится, как только запись разойдётся по сети.',
  ),
  'publish.done.back': text('Back to the site', 'Вернуться к сайту'),
  'publish.stopped': text('Publishing stopped', 'Публикация остановлена'),
  'publish.startOver': text('Start over', 'Начать заново'),
  'publish.notSent': text(
    'The transaction was not sent. Nothing changed on chain.',
    'Транзакция не отправлена. В сети ничего не изменилось.',
  ),

  'versions.title': text('History', 'История'),
  'versions.restoreFailed': text('Could not restore', 'Не удалось восстановить'),
  'versions.empty': text('No versions yet.', 'Версий пока нет.'),
  'versions.number': text('Version {n}', 'Версия {n}'),
  'versions.restore': text('Restore', 'Восстановить'),
  'versions.current': text('Current', 'Текущая'),
  'versions.hint': text(
    'Restoring loads that version back into the editor. Putting it on chain still needs one signature, but the bag is reused, so nothing is rebuilt.',
    'Восстановление загружает версию обратно в редактор. Публикация всё равно потребует одной подписи, но bag переиспользуется и ничего не пересобирается.',
  ),

  'status.DRAFT': text('Draft', 'Черновик'),
  'status.BUILDING': text('Packing', 'Упаковка'),
  'status.BUILT': text('Ready to sign', 'Готово к подписи'),
  'status.PUBLISHING': text('Confirming', 'Подтверждение'),
  'status.LIVE': text('Live', 'Опубликован'),
  'status.FAILED': text('Failed', 'Ошибка'),
  'status.SUPERSEDED': text('Replaced', 'Заменена'),

  'template.title': text('Change template', 'Сменить шаблон'),
  'template.subtitle': text(
    'Pick a different look, or move to your own code. Nothing is published until you publish it, and uploaded files stay where they are.',
    'Выберите другое оформление или перейдите на свой код. Ничего не публикуется, пока вы не опубликуете, а загруженные файлы остаются на месте.',
  ),
  'template.current': text('Current', 'Сейчас используется'),
  'template.toCustom': text(
    'Edit the HTML, CSS and JavaScript yourself',
    'Править HTML, CSS и JavaScript самому',
  ),
  'template.apply': text('Switch', 'Переключить'),
  'template.failed': text('Could not switch', 'Не удалось переключить'),
  'template.warn.title': text('What happens to your content', 'Что будет с содержимым'),
  'template.warn.toCustom': text(
    'Your current page is copied into the editor as HTML, CSS and JavaScript, images included. You can carry on from there.',
    'Текущая страница переносится в редактор как HTML, CSS и JavaScript, вместе с картинками. Можно править дальше с того же места.',
  ),
  'template.warn.toTemplate': text(
    'The new template starts empty and you fill it in again. Field names differ between templates, so carrying values across would put text in the wrong places.',
    'Новый шаблон начнётся пустым, поля надо заполнить заново. Названия полей у шаблонов разные, и перенос значений расставил бы текст не туда.',
  ),
  'template.historyHint': text(
    'The current version stays in history and can be restored.',
    'Текущая версия остаётся в истории, её можно восстановить.',
  ),
  'site.changeTemplate': text('Change template', 'Сменить шаблон'),

  'plans.title': text('Plans', 'Тарифы'),
  'plans.subtitle': text(
    'Building and previewing are free. A plan is what keeps a site published and served.',
    'Сборка и предпросмотр бесплатны. Тариф нужен, чтобы сайт оставался опубликованным и отдавался посетителям.',
  ),
  'plans.forSite': text('For {domain}', 'Для {domain}'),
  'plans.sectionSite': text('One site', 'Один сайт'),
  'plans.sectionAccount': text('Several sites', 'Несколько сайтов'),
  'plans.quota': text('up to {count} sites', 'до {count} сайтов'),
  'plans.forever': text('Forever, one payment', 'Навсегда, один платёж'),
  'plans.period.MONTH': text('1 month', '1 месяц'),
  'plans.period.QUARTER': text('3 months', '3 месяца'),
  'plans.period.HALF_YEAR': text('6 months', '6 месяцев'),
  'plans.period.YEAR': text('1 year', '1 год'),
  'plans.period.LIFETIME': text('Forever', 'Навсегда'),
  'plans.pay': text('Pay {amount} GRAM', 'Оплатить {amount} GRAM'),
  'plans.paying': text('Confirm in your wallet', 'Подтвердите в кошельке'),
  'plans.waiting': text('Waiting for the payment', 'Ждём платёж'),
  'plans.waitingHint': text(
    'The transfer is on its way. This usually takes a few seconds.',
    'Перевод отправлен. Обычно это занимает несколько секунд.',
  ),
  'plans.paid.title': text('Payment received', 'Платёж получен'),
  'plans.paid.body': text(
    'The plan is active. You can publish now.',
    'Тариф активен. Можно публиковать.',
  ),
  'plans.failed': text('The payment did not go through', 'Платёж не прошёл'),
  'plans.notSent': text(
    'Nothing was sent and nothing was charged.',
    'Ничего не отправлено и не списано.',
  ),
  'plans.empty': text('No plans are available.', 'Тарифов пока нет.'),
  'plans.loadFailed': text('Could not load the plans', 'Не удалось загрузить тарифы'),
  'plans.needWallet': text('Connect your wallet to pay.', 'Подключите кошелёк, чтобы оплатить.'),
  'plans.retry': text('Try again', 'Попробовать снова'),
  'plans.done': text('Back to the site', 'Вернуться к сайту'),
  'plans.badge': text('Paid', 'Платно'),

  'billing.trial.title': text('Trial period', 'Пробный период'),
  'billing.trial.body': text(
    '{days} day(s) left. One site stays published for free until then.',
    'Осталось {days} дн. До этого один сайт публикуется бесплатно.',
  ),
  'billing.trial.lastDay': text(
    'The trial ends today. Choose a plan to keep your site online.',
    'Пробный период заканчивается сегодня. Выберите тариф, чтобы сайт не отключился.',
  ),
  'billing.quota': text('Sites: {used} of {quota}', 'Сайтов: {used} из {quota}'),
  'billing.choosePlan': text('Choose a plan', 'Выбрать тариф'),

  'site.needsPlan.title': text('A plan is needed to publish', 'Для публикации нужен тариф'),
  'site.needsPlan.body': text(
    'Your edits are saved and the preview works. Publishing puts the site on your domain and keeps it served, and that is the part a plan pays for.',
    'Правки сохранены, предпросмотр работает. Публикация размещает сайт на вашем домене и держит его доступным — именно за это и берётся плата.',
  ),
  'site.quotaFull.title': text('Your plan is full', 'Тариф заполнен'),
  'site.quotaFull.body': text(
    'Every site your plan covers is already published. Upgrade, or buy a plan for this one site.',
    'Все сайты, которые покрывает тариф, уже опубликованы. Перейдите на больший тариф или купите тариф на этот сайт.',
  ),
  'site.suspended.title': text('This site is not being served', 'Сайт сейчас не отдаётся'),
  'site.suspended.body': text(
    'The subscription ran out. Nothing has been deleted: renew and the site comes straight back. Your domain and its DNS record stay yours either way.',
    'Подписка закончилась. Ничего не удалено: продлите — и сайт сразу вернётся. Домен и его DNS-запись в любом случае остаются вашими.',
  ),
  'site.coveredUntil': text('Paid until {date}', 'Оплачен до {date}'),
  'site.coveredForever': text('Paid for, forever', 'Оплачен навсегда'),
  'site.renew': text('Renew', 'Продлить'),

  'plans.sectionCustomCode': text('Custom code', 'Свой код'),
  'plans.customCode.hint': text(
    'Write your own HTML, CSS and JavaScript. One unlock covers every domain on the account, and it is separate from a site plan.',
    'Свои HTML, CSS и JavaScript. Одна покупка открывает режим для всех доменов аккаунта; от тарифа на сайты она не зависит.',
  ),
  'plans.customCode.until': text('Unlocked until {date}', 'Открыт до {date}'),
  'plans.customCode.forever': text('Unlocked, no end date', 'Открыт бессрочно'),
  'plans.customCode.trial': text(
    'Included in your trial period, until {date}',
    'Входит в пробный период, до {date}',
  ),

  'new.custom.locked': text(
    'A separate unlock, from {price} GRAM. Tap to see it.',
    'Отдельная покупка, от {price} GRAM. Нажмите, чтобы посмотреть.',
  ),
  'new.custom.lockedNoPrice': text(
    'A separate unlock. Tap to see it.',
    'Отдельная покупка. Нажмите, чтобы посмотреть.',
  ),

  'site.needsCustomCode.title': text('Custom code is not unlocked', 'Свой код не оплачен'),
  'site.needsCustomCode.body': text(
    'Writing your own HTML, CSS and JavaScript is bought separately from a site plan. Your code is saved and the preview works; publishing is what needs the unlock.',
    'Свои HTML, CSS и JavaScript покупаются отдельно от тарифа на сайты. Код сохранён и предпросмотр работает — оплата нужна для публикации.',
  ),
  'billing.unlockCode': text('Unlock custom code', 'Открыть свой код'),

  'common.back': text('Back', 'Назад'),
  'common.close': text('Close', 'Закрыть'),
} as const satisfies Record<string, LocalizedText>;

export type MessageKey = keyof typeof DICTIONARY;
